import { useEffect, useState, useRef, useMemo } from 'react'
import { useWeb3React } from 'lib/wagmi-compat/useWeb3React'
import { simpleRpcProvider, getSimpleRpcProviderByChainId } from 'utils/providers'

/**
 * Provides a web3 provider with or without user's signer
 * Recreate web3 instance only if the provider change
 */
const useActiveWeb3React = (chainId?: number) => {
  const { provider: prov, chainId: web3ChainId, ...web3React } = useWeb3React()
  const refEth = useRef(prov)
  const [provider, setProvider] = useState(prov || simpleRpcProvider)

  useEffect(() => {
    if (prov !== refEth.current) {
      setProvider(prov || simpleRpcProvider)
      refEth.current = prov
    }
  }, [prov, chainId])

  const customProvider = useMemo(() => {
    // If web3 has chainId and provided chainId is the same, use web3 provider
    if (chainId && web3ChainId && chainId === web3ChainId) {
      return provider
    }
    // If chainId is provided and web3 has no chainId, use getSimpleRpcProviderByChainId
    if (chainId) {
      return getSimpleRpcProviderByChainId(chainId)
    }
    if (web3ChainId) {
      return provider
    }
    return simpleRpcProvider
  }, [provider, chainId, web3ChainId])

  return {
    provider: customProvider,
    chainId: web3ChainId ?? chainId,
    ...web3React
  }
}

export default useActiveWeb3React
